import { memo } from 'react';
import ItemsGrid from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsGrid';
import ItemsScrollBar from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsScrollBar';
import BasicBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/BasicBtn';
import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import CategoryMenuBar from '@wconcept/wconcept-ui-renewal/components/organisms/_menuBar/CategoryMenuBar';
import { IconWatch01 } from '@wconcept/wconcept-ui-renewal/src/components/atoms/svg';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
  pointColor?: string;
  emphasisTextColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

interface IProps {
  title?: string;
  subTitle?: string;
  updateTime?: string;
  colorType?: ColorType;
  categoryTabList?: React.ReactNode[];
  selectedCateTabId?: string;
  productList?: React.ReactNode[];
  isDesktop?: boolean;
  scrollRef?: React.RefObject<HTMLDivElement | null>;
  isLink?: boolean;
  /** false이면 하단 더보기 버튼 미노출 (메가 랭킹: 모듈 내 확장만 사용할 때) */
  showMoreButton?: boolean;
  isLoaded?: boolean;
  onClickMore?: () => void;
}

const RankingProductSection = ({
  title = '',
  subTitle,
  updateTime,
  colorType = 'white',
  categoryTabList,
  selectedCateTabId,
  productList,
  isDesktop,
  scrollRef,
  isLink = false,
  showMoreButton = true,
  isLoaded,
  onClickMore,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'mega-ranking-product',
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);

  const getDesktopItems = () => (
    <ItemsGrid colGap={18} perView={6} rowGap={40}>
      {productList}
    </ItemsGrid>
  );

  const getMobileItems = () => {
    if (!productList || productList.length === 0) return null;

    const per = 4;
    const total = Math.ceil(productList.length / per);
    const tempData = [];
    for (let i = 0; i < total; i++) {
      tempData.push(productList.slice(i * per, per * (i + 1)));
    }
    return tempData.map((items, i) => (
      <ItemsGrid
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        colGap={0}
        perView={1}
        rowGap={16}
      >
        {items}
      </ItemsGrid>
    ));
  };

  return (
    <S.RankingProductSection
      className={cName}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
      $pointColor={customColors?.pointColor}
      $emphasisTextColor={customColors?.emphasisTextColor}
    >
      <ContTitle
        title={title}
        subTitle={subTitle}
        titleColor={customColors?.textColor}
        subTitleColor={customColors?.textColor}
      />

      <span className="update-time">
        <IconWatch01 />
        {updateTime} 업데이트
      </span>

      {isDesktop ? (
        <>
          <div className="category-tab">{categoryTabList}</div>
          {getDesktopItems()}
        </>
      ) : (
        <>
          {categoryTabList && (
            <CategoryMenuBar
              type="type1"
              bgType={
                !isCustomColor ? (colorType as 'white' | 'black') : undefined
              }
              items={categoryTabList}
              selectedValue={selectedCateTabId}
              className="category-tab"
            />
          )}
          {isLoaded ? (
            <ItemsScrollBar perView={1.136} colGap={16} snap ref={scrollRef}>
              {getMobileItems()}
            </ItemsScrollBar>
          ) : (
            <ItemsGrid
              perView={3}
              colGap={6}
              rowGap={24}
              className="skeleton-list"
            >
              {productList}
            </ItemsGrid>
          )}
        </>
      )}
      {showMoreButton && (
        <BasicBtn
          className="btn-section-more"
          text={isLink ? '상품 전체 보기' : '상품 더보기'}
          type={isLink ? 'line' : 'lineDropdown'}
          onClick={onClickMore}
        />
      )}
    </S.RankingProductSection>
  );
};

export default memo(RankingProductSection);
